import { useFetchMgItemCard } from '@retail/products/data-access';
import { MgItemCard } from '@retail/products/types';

import {
  ErrorFallback,
  SuspenseWithSentryErrorBoundary,
  withDialogSuspenseErrorBoundary,
} from '@retail/components';
import { DialogContent } from '@mui/material';
import { Dialog } from '@shared/components';
import React from 'react';

interface ChildrenProps {
  mgItem: MgItemCard;
}

interface Props {
  itemNumber: number;
  open: boolean;
  onClose: () => void;
  children: (props: ChildrenProps) => React.ReactNode;
}

export const MgItemDialogContainer = withDialogSuspenseErrorBoundary(
  ({ itemNumber, open, onClose, children }: Props) => {
    const { data: mgItemDto } = useFetchMgItemCard(
      {
        mgItemNumber: itemNumber,
      },
      { suspense: true }
    );

    const mgItem = MgItemCard.fromDto(mgItemDto!);

    return (
      <Dialog open={open} onClose={onClose} maxWidth="xl">
        <DialogContent sx={{ px: 0 }}>
          <SuspenseWithSentryErrorBoundary
            errorFallback={(props) => <ErrorFallback {...props} message={props.error.message} />}
          >
            {children({ mgItem })}
          </SuspenseWithSentryErrorBoundary>
        </DialogContent>
      </Dialog>
    );
  }
);
